const CONFIG = {
  API_BASE_URL: 'https://lsmbo-brownotate.u-strasbg.fr/api'
};
export default CONFIG;